'use strict';

import Component from 'generic.basecomponent';
import $ from "jquery";
import app from 'app-instance';



export default class LoginBlock extends Component {
    constructor(el) {
        super(el);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.handleGuest = this.handleGuest.bind(this);
        this.amountChange = this.amountChange.bind(this);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        this.step = this.$container.hasClass('is-step-2') || this.$container.attr('data-has-error') ? 2 : 1;
        this.$switchBtn = this.$container.find('.js-login-block__switch');
        this.$guestBtn = this.$container.find('.js-login-block__guest');
        this.$donationInp = this.$container.find('.js-login-block__donation');

        app.addListener('donateAmount:change', this.amountChange);
        app.addListener('donateAmount:input', this.amountChange);
        this.$switchBtn.on('click', this.handleSwitch);
        this.$guestBtn.on('click', this.handleGuest);
        this.$container.addClass(`is-step-${this.step}`);

    }

    handleSwitch() {
        const prevStep = this.step;
        this.step = prevStep === 1 ? 2 : 1;
        this.$container.addClass(`is-step-${this.step}`);
        this.$container.removeClass(`is-step-${prevStep}`);
    }



    handleGuest() {
        window.__doPostBack(this.$guestBtn.data('clientid'), '');
    }

    amountChange(value) {
        this.$donationInp.val(value);
    }

    destroy() {
        super.destroy();
        this.$switchBtn.off('click', "", this.handleSwitch);
        this.$guestBtn.off('click', "", this.handleGuest);
        app.removeListener('donateAmount:change', this.amountChange);
        app.removeListener('donateAmount:input', this.amountChange);
        this.$container.removeClass('js-login-block-inited');

    }


}



// WEBPACK FOOTER //
// ./app/components/login-block/js/generic.login-block.js